'use strict';

var MemberApp = angular.module('MemberApp');

MemberApp.directive('pleaseWait', function() {
  return {
    restrict: 'E',
    templateUrl: 'scripts/directives/please-wait/please-wait.prt.html',
    controller: function($scope) {
      let now = new Date();
      const classPrefix = 'please-wait__spinner__';
      let currentYear = now.getFullYear();

      // winter wraps around
      let seasons = [
        {
          'winter': {
            'start': new Date(currentYear, 0, 1),
            'end': new Date(currentYear, 2, 1)
          }
        },
        {
          'pre_spring': {
            'start': new Date(currentYear, 2, 2),
            'end': new Date(currentYear, 2, 20)
          }
        },
        {
          'spring': {
            'start': new Date(currentYear, 2, 21),
            'end': new Date(currentYear, 5, 20)
          }
        },
        {
          'summer': {
            'start': new Date(currentYear, 5, 21),
            'end': new Date(currentYear, 8, 20)
          }
        },
        {
          'fall': {
            'start': new Date(currentYear, 8, 21),
            'end': new Date(currentYear, 11, 20)
          }
        },
        {
          'winter': {
            'start': new Date(currentYear, 11, 21),
            'end': new Date(currentYear, 11, 31)
          }
        }
      ];

      seasons.forEach((season) => {
        let seasonDates = season[Object.keys(season)[0]];
        if (seasonDates.start <= now && now <= seasonDates.end) {
          $scope.season = `${classPrefix + Object.keys(season)[0]}`;
        }
      });
    }
  };
});
